module.exports = __webpack_public_path__ + "img/avatar.729ab867.png";